import React, { useEffect, useRef } from "react";
import { animate, motion, useInView, useReducedMotion } from "framer-motion";
import "./Stats.css";

// TODO: placeholder figures. Replace with Cristal Inox's real numbers.
const STATS = [
  { value: 15, suffix: "+", label: "Années d'expérience" },
  { value: 500, suffix: "+", label: "Projets réalisés" },
  { value: 300, suffix: "+", label: "Clients satisfaits" },
  { value: 100, suffix: "%", label: "Sur mesure" },
];

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: reduceMotion ? 0 : 2,
      ease: "easeOut",
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = `${Math.round(v)}${suffix}`;
      },
    });
    return () => controls.stop();
  }, [inView, value, suffix, reduceMotion]);

  return <span ref={ref}>{`0${suffix}`}</span>;
}

function Stats() {
  return (
    <section className="stats">
      <div className="stats__grid">
        {STATS.map((stat, i) => (
          <motion.div
            className="stats__item"
            key={stat.label}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: i * 0.15 }}
          >
            <div className="stats__value">
              <Counter value={stat.value} suffix={stat.suffix} />
            </div>
            <div className="stats__label">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
